'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { GenderToggle } from './GenderToggle';
import type { Gender } from './types';
import styles from './LeaderboardStickyBar.module.css';

type LeaderboardStickyBarProps = {
  visible: boolean;
  headerOffset: number;
  gender: Gender;
  onGenderChange: (gender: Gender) => void;
};

export const LeaderboardStickyBar: React.FC<LeaderboardStickyBarProps> = ({
  visible,
  headerOffset,
  gender,
  onGenderChange,
}) => {
  const t = useTranslations('performance-lab');
  const title = t('leaderboard.title');

  return (
    <div
      className={styles.bar}
      data-visible={visible}
      style={{ ['--header-offset']: `${headerOffset}px` } as React.CSSProperties}
      aria-hidden={!visible}
    >
      <div className={styles.barInner}>
        <div className={styles.innerMobile}>
          <h2 className={styles.compactTitle}>{title}</h2>
          <div className={styles.toggleSlot}>
            <GenderToggle value={gender} onChange={onGenderChange} />
          </div>
        </div>
        <div className={styles.innerDesktop}>
          <h2 className={styles.compactTitle}>{title}</h2>
          <div className={styles.toggleSlot}>
            <GenderToggle value={gender} onChange={onGenderChange} />
          </div>
        </div>
      </div>
    </div>
  );
};
